import type { Editor, Range } from '@tiptap/core';
import {
  CodeSquareIcon,
  FileTextIcon,
  Heading1Icon,
  Heading2Icon,
  Heading3Icon,
  ImageIcon,
  ListIcon,
  ListOrderedIcon,
  QuoteIcon,
  SeparatorHorizontalIcon,
  Table2Icon,
  TypeIcon,
  VideoIcon,
} from 'lucide-react';

export type SlashMenuCommandType = {
  name: string;
  command: (params: { editor: Editor; range: Range }) => void;
  icon: React.ElementType;
};

export const slashMenuCommands: SlashMenuCommandType[] = [
  {
    name: 'Bulleted list',
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).toggleBulletList().run();
    },
    icon: ListIcon,
  },
  {
    name: 'Numbered list',
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).toggleOrderedList().run();
    },
    icon: ListOrderedIcon,
  },
  {
    name: 'Block quote',
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).setBlockquote().run();
    },
    icon: QuoteIcon,
  },
  {
    name: 'Code Block',
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).setCodeBlock({ language: 'auto' }).run();
    },
    icon: CodeSquareIcon,
  },
  {
    name: 'Paragraph',
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).setNode('paragraph').run();
    },
    icon: TypeIcon,
  },
  {
    name: 'Separator',
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).setHorizontalRule().run();
    },
    icon: SeparatorHorizontalIcon,
  },
  {
    name: 'Table',
    command: ({ editor, range }) => {
      editor
        .chain()
        .focus()
        .deleteRange(range)
        .insertTable({ rows: 3, cols: 3, withHeaderRow: true })
        .run();
    },
    icon: Table2Icon,
  },
  {
    name: 'Heading 1',
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).setNode('heading', { level: 1 }).run();
    },
    icon: Heading1Icon,
  },
  {
    name: 'Heading 2',
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).setNode('heading', { level: 2 }).run();
    },
    icon: Heading2Icon,
  },
  {
    name: 'Heading 3',
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).setNode('heading', { level: 3 }).run();
    },
    icon: Heading3Icon,
  },
  {
    name: 'Image',
    command: ({ editor, range }) => {
      editor
        .chain()
        .focus()
        .deleteRange(range)
        .insertContentAt(range.from, {
          type: 'image-dialog',
        })
        .insertContentAt(range.from, '<p></p>')
        .run();
    },
    icon: ImageIcon,
  },
  {
    name: 'Video',
    command: ({ editor, range }) => {
      editor
        .chain()
        .focus()
        .deleteRange(range)
        .insertContentAt(range.from, {
          type: 'video-dialog',
        })
        .insertContentAt(range.from, '<p></p>')
        .run();
    },
    icon: VideoIcon,
  },
  {
    name: 'PDF',
    command: ({ editor, range }) => {
      editor
        .chain()
        .focus()
        .deleteRange(range)
        .insertContentAt(range.from, {
          type: 'pdf-dialog',
        })
        .insertContentAt(range.from, '<p></p>')
        .run();
    },
    icon: FileTextIcon,
  },
];
